// extracted by mini-css-extract-plugin
export default {"card":"card__LVisI","cardHeader":"cardHeader__2mDXR","logo":"logo__iRp_P","cardFooter":"cardFooter__2GgWj"};